var React       = require('react');
var map         = require('lodash/collection/map');
var some        = require('lodash/collection/some');
var Actions     = require('./state');

var Question    = require('./components/question');
var QuizActions = require('./components/quiz_actions');
var Errors      = require('./components/errors');
var { withNamespaces } = require('react-i18next');

var Quiz = React.createClass({
  propTypes : {
    challengeId: React.PropTypes.number.isRequired,
    stageId: React.PropTypes.number.isRequired,
    questions: React.PropTypes.object.isRequired,
    csrfToken: React.PropTypes.string.isRequired,
    submitLabel: React.PropTypes.string.isRequired,
    // completed: answer was submitted but advocate did not click on continue
    completed: React.PropTypes.bool.isRequired,
    correctAnswers: React.PropTypes.array,
    errorMsg: React.PropTypes.string,
    status: React.PropTypes.string,
    pointsEarned: React.PropTypes.number,
    totalQuestions: React.PropTypes.number,
    correctQuestions: React.PropTypes.number,
    quizAnswered:  React.PropTypes.bool
  },

  getInitialState: function() {
    return {
      saving: false
    }
  },

  getDefaultProps: function() {
    return {
      correct: null,
      errorMsg: null,
      pointsEarned: 0,
      totalQuestions: 0,
      correctQuestions: 0,
      status: 'unsaved',
      quizAnswered: false
    };
  },

  render: function () {
    return (
      <div className='pt-form'>
        <Errors errorMsg={this.props.errorMsg} />

        { this._renderQuestions() }

        <p className="c-response-visibility" style={this.styles.note}>{this.props.t("Your responses won't be visible to other advocates.")}</p>
        <QuizActions onSubmit={this._handleSubmit} submitDisabled={this._submitDisabled()} {...this.props} />
      </div>
    );
  },

  _renderQuestions: function() {
    let questionOrdinal = 0;
    return map(this.props.questions, function(question, id){
      questionOrdinal++;
      return <Question
        questionOrdinal={questionOrdinal}
        question={question}
        id={id}
        key={id} />;
    });
  },

  _handleSubmit: function () {
    this.setState({ saving: true })
    Actions.trigger("submit", this.props.stageId, this.props.csrfToken);
  },

  _submitDisabled: function() {
    const saving = this.state.saving
    return some(this.props.questions, function(question){
      return question.selectedAnswer === null || saving;
    });
  },

  styles: {
    note: {
      fontSize: '11px',
      color: '#d0d2d3', //patternity light grey
      marginTop: '10px'
    }
  }
});

module.exports = withNamespaces()(Quiz);



// WEBPACK FOOTER //
// ./src/advocate/stages/quiz/quiz.jsx